/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCheckbox/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TysiaCheckbox({
  children,
  viewPath = "/DesignSystem/TysiaCheckbox",
  disabled,
  marginTop = 0,
  marginRight = 0,
  marginBottom = 0,
  marginLeft = 0,
  onChange,
  onMouseEnter,
  onMouseLeave,
  title,
  focused,
  hovered,
  invalid,
  valid,
  value,
  onBlur,
  onFocus,
  onSubmit,
  size,
  required,
  isSelected
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
  return (<React.Fragment
>
<button
  data-testid="TysiaCheckbox.Horizontal"
  data-view-path={viewPath}
 disabled={disabled}
 {...isHoveredBind}
 onClick={onChange}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 title={title}
 style={{'--mt-2-Z2n9zs2': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-3-Z2n9zs2': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mb-4-Z2n9zs2': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-5-Z2n9zs2': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--c-1-Z2n9zs2': disabled ? "default" : "pointer"}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 value={value}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 size={size}
 required={required}
 isSelected={isSelected} isHovered={isHovered} isSelectedHovered={isSelectedHovered}
>
{children}
</Children>
</button>
</React.Fragment>)
}